import { Loader } from '@servicetitan/web-components';
import { FC, useMemo } from 'react';
import { Page, Text, Spinner } from '@servicetitan/anvil2';
import * as Styles from './main-page.module.less';
import { useDependencies } from '@servicetitan/react-ioc';
import { AppStore } from '../stores/app.store';
import { observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import classnames from 'classnames';
import { getTaskHubEnvironmentMfeTag, getTaskHubEnvironment } from 'shared';

/*
 * This host app is always served from the Task Hub BFF, so getTaskHubEnvironment()
 * can reliably detect the environment from window.location.hostname.
 */
const environment = getTaskHubEnvironment();

const AppSidebar: FC = () => (
    <Page.Sidebar>
        <Page.SidebarHeader>
            <Text variant="headline" el="h2">
                Task Hub
            </Text>
        </Page.SidebarHeader>
    </Page.Sidebar>
);

const getMfeUrl = () => {
    const local = 'http://localhost:9010';
    const mfeTag = getTaskHubEnvironmentMfeTag(environment);

    return process.env.NODE_ENV === 'development'
        ? local
        : `https://unpkg.servicetitan.com/@servicetitan/task-hub@${mfeTag}`;
};

export const MainPage: FC = observer(() => {
    const mfeUrl = getMfeUrl();

    const [{ authorized, orgId: orgId }] = useDependencies(AppStore);

    const mfeData = useMemo(
        () => ({
            orgId: orgId ?? '',
            contextKey: 'production',
            environment,
        }),
        [orgId]
    );

    if (!authorized) {
        return <Redirect to={{ pathname: '/login' }} />;
    }

    return (
        <Page>
            <AppSidebar />
            <Page.Content
                className={classnames(Styles.pageContent, 'a2-p-12')}
                data-testid="main-page-content"
            >
                <Loader
                    src={mfeUrl}
                    data={mfeData}
                    loadingFallback={<Spinner size="medium" />}
                    errorFallback={<Text>Please refresh this page, or try again later.</Text>}
                />
            </Page.Content>
        </Page>
    );
});
